import { useSincronizacao } from "../offline/sync";

/**
 * Fase 6 (offline-first): mostra se há mudanças ainda não enviadas ao servidor e permite forçar
 * uma tentativa. `pendentes` reflete a fila real em IndexedDB (não um contador só de tela), então
 * continua correto mesmo depois de recarregar a página com itens ainda na fila.
 */
export function IndicadorSincronizacao() {
  const { pendentes, online, sincronizando, sincronizarAgora } = useSincronizacao();

  if (!online) {
    return (
      <div className="alerta" style={{ background: "var(--fundo)", border: "1px solid var(--borda)", fontSize: 13 }}>
        📴 Sem conexão — {pendentes > 0 ? `${pendentes} alteração${pendentes > 1 ? "ões" : ""} salva${pendentes > 1 ? "s" : ""} no aparelho, envia sozinho quando a rede voltar` : "tudo o que você fizer fica salvo no aparelho até a rede voltar"}
      </div>
    );
  }

  if (pendentes === 0 && !sincronizando) {
    return null; // online e tudo sincronizado — sem indicador nenhum, não precisa poluir a tela
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
        fontSize: 13,
        padding: "8px 12px",
        borderRadius: 8,
        background: "var(--primaria-clara)",
        color: "var(--primaria-escura)",
        marginBottom: 12,
      }}
    >
      <span>
        {sincronizando
          ? "Sincronizando…"
          : `${pendentes} alteração${pendentes > 1 ? "ões" : ""} pendente${pendentes > 1 ? "s" : ""}`}
      </span>
      {!sincronizando && (
        <button className="botao botao-texto" style={{ padding: "2px 8px" }} onClick={sincronizarAgora}>
          Sincronizar agora
        </button>
      )}
    </div>
  );
}
